import React from "react";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";
import AboutSection from "../../components/aboutus/AboutSection";
import HowToFindLawyer from "../../components/aboutus/HowToFindLawyer";
import TestimonialsSection from "../../components/aboutus/TestimonialsSection";
import JoinAsLawyer from "../../components/home/JoinAsLawyer";
import { useTranslation } from "react-i18next";

export default function AboutUs() {
  const { t } = useTranslation();
  return (
    <>
      <Seo
        title={copy.page(currentLang(), "about").title}
        description={copy.page(currentLang(), "about").description}
        path={urls.sectionPath("about", currentLang())}
        alternates={urls.alternates((l) => urls.sectionPath("about", l))}
      />
      <AboutSection />
      <HowToFindLawyer />
      <TestimonialsSection />
      <JoinAsLawyer />
    </>
  );
}
